import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  render: h => h(App)
});

function injectInitialState(state) {
  const script = document.createElement(`script`);
  script.innerHTML = `window.__INITIAL_STATE__ = ${JSON.stringify(state)}`;
  document.head.appendChild(script);
}

// During pre-rendering the initial state is
// injected into the global scope, here we
// fill the store with the initial state.
if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__);

router.beforeResolve(async (to, from, next) => {
  // method to resolve before rendering the view.
  // console.log(store.state.CityContent);
  try {
    const components = router.getMatchedComponents(to);
    // By using `await` we make sure to wait
    // for the API request made by the `fetch()`

    await Promise.all(
      components.map(
        x =>
          x.methods.preFetchCategoryStore &&
          x.methods.preFetchCategoryStore(store)
      )
    );
    await Promise.all(
      components.map(
        x =>
          x.methods.preFetchMicroContentStore &&
          x.methods.preFetchMicroContentStore(store)
      )
    );
    // The `injectInitialState()` function injects
    // the current state as a global variable
    // `__INITIAL_STATE__` if the page is currently
    // pre-rendered.

    if (window.__PRERENDER_INJECTED) injectInitialState(store.state);
  } catch (error) {
    // This is the place for error handling in
    // case the API request fails for example.
    throw error;
  }

  return next();
});

app.$mount("#app");
